<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Radio, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;
</script>

{#if /^presencezone\.(setconfig)$/.test(controlOption?.value)}
	<div class="d-flex flex-direction-column">
		<Text class="mt-s mb-s" size="m">
			{capFirstChar($format('enable', { default: 'enable' }))}
		</Text>
		<Radio
			id="radio-presencezone-setconfig-enable"
			class="d-inline-flex mb-xs"
			value="true"
			selected={String(controlOption.params.config.enable)}
			on:click={() => (controlOption.params.config.enable = true)}
			size="m"
		>
			{capFirstChar($format('on_action', { default: 'on' }))}
		</Radio>
		<Radio
			id="radio-presencezone-setconfig-disable"
			class="d-inline-flex mb-m"
			value="false"
			selected={String(controlOption.params.config.enable)}
			on:click={() => (controlOption.params.config.enable = false)}
			size="m"
		>
			{capFirstChar($format('off_action', { default: 'off' }))}
		</Radio>
	</div>
{/if}
